"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selection = exports.PUBLIC_PERFORMERS_FLAG = exports.EXPERIMENTNAME_OVERRIDE_PREFIX = exports.EXPERIMENT_WEIGHTS = void 0;
exports.loggedOutRecIsValid = loggedOutRecIsValid;
exports.getLoggedOutRec = getLoggedOutRec;
exports.clearLoggedOutRecommender = clearLoggedOutRecommender;
var RecommenderSession_1 = require("./RecommenderSession");
var StatsDClient_1 = require("./StatsDClient");
var DEFAULT_LOGGEDOUTREC = "performers";
exports.EXPERIMENT_WEIGHTS = { names: ["performers", "publicPerformers"], weights: [0.5, 0.5] };
exports.EXPERIMENTNAME_OVERRIDE_PREFIX = "override-";
exports.PUBLIC_PERFORMERS_FLAG = "publicPerformers";
var loggedoutSelectionOn = Boolean(localStorage.getItem("loggedoutSelectionOverride"));
var publicPerformersExperimentEnabled = localStorage.getItem(exports.PUBLIC_PERFORMERS_FLAG) === "true";
function loggedOutRecIsValid(session) {
    var isLoggedIn = (session !== null && session !== void 0 ? session : (0, RecommenderSession_1.getRecommenderSession)()).isLoggedIn;
    return Boolean((!isLoggedIn || loggedoutSelectionOn) && publicPerformersExperimentEnabled);
}
function getLoggedOutRec() {
    var session = (0, RecommenderSession_1.getRecommenderSession)();
    var experimentName = session.experimentName;
    // strip prefix of "overrride-" if there is any
    if (experimentName === null || experimentName === void 0 ? void 0 : experimentName.startsWith(exports.EXPERIMENTNAME_OVERRIDE_PREFIX)) {
        experimentName = experimentName.slice(exports.EXPERIMENTNAME_OVERRIDE_PREFIX.length);
    }
    var isValid = Boolean(loggedOutRecIsValid(session));
    var selection = isValid ? experimentName : null;
    if (!selection) {
        if (isValid) {
            selection = getSelection();
        }
        selection = selection !== null && selection !== void 0 ? selection : DEFAULT_LOGGEDOUTREC;
        if (publicPerformersExperimentEnabled) {
            (0, RecommenderSession_1.updateRecommenderSession)({ experimentName: selection });
        }
    }
    return selection;
}
function clearLoggedOutRecommender() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            (0, RecommenderSession_1.sendRecommenderSessionEvent)("clearLoggedoutSelection");
            if (publicPerformersExperimentEnabled) {
                (0, RecommenderSession_1.updateRecommenderSession)({ experimentName: "fallback" });
            }
            return [2 /*return*/];
        });
    });
}
function getSelection() {
    exports.selection = exports.selection !== null && exports.selection !== void 0 ? exports.selection : rollForSelection(exports.EXPERIMENT_WEIGHTS);
    return exports.selection;
}
function rollForSelection(_a) {
    var weights = _a.weights, names = _a.names;
    var experimentName;
    experimentName = names[Math.floor(Math.random() * names.length)];
    experimentName = experimentName ? experimentName : DEFAULT_LOGGEDOUTREC; // is this really needed??
    StatsDClient_1.statsd.count("recommenders.experiment-selection.".concat(experimentName));
    (0, RecommenderSession_1.updateRecommenderSession)({ experimentName: experimentName });
    (0, RecommenderSession_1.sendRecommenderSessionEvent)("loggedoutSelection");
    return experimentName;
}
//# sourceMappingURL=RecommenderExperiment.js.map